import { render, staticRenderFns } from "./DetailById.vue?vue&type=template&id=dd3146f8&"
import script from "./DetailById.vue?vue&type=script&lang=js&"
export * from "./DetailById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports